import {createReducer} from "redux-act";
import {
	openLoginModal,
	closeLoginModal,
	closeShareModal,
	openShareModal,
	openErrorLeagueModal,
	closeErrorLeagueModal,
	openGotcLeagueModal,
	closeGotcLeagueModal,
} from "modules/actions";
import {ISaveShareParameters, IShareParameters} from "modules/types";

interface IModalsReducer {
	loginModal: {
		isOpen: boolean;
		text?: string;
		redirectPath?: string;
		data?: Record<string, unknown>;
	};
	shareModal: {
		isOpen: boolean;
		title?: string;
		description?: string;
		shareParameters?: IShareParameters;
		saveShareParameters?: ISaveShareParameters;
	};
	gotcLeagueModal: {
		isOpen: boolean;
	};
	errorLeagueModal: {
		message: string;
	};
}

const initial: IModalsReducer = {
	loginModal: {
		isOpen: false,
	},
	shareModal: {
		isOpen: false,
	},
	gotcLeagueModal: {
		isOpen: false,
	},
	errorLeagueModal: {
		message: "",
	},
};

export const global_modals = createReducer({}, initial)
	.on(openLoginModal, (state, payload) => ({
		...state,
		loginModal: {
			isOpen: true,
			text: payload.text,
			redirectPath: payload.redirectPath,
			data: payload.data,
		},
	}))
	.on(closeLoginModal, (state) => ({
		...state,
		loginModal: {
			isOpen: false,
			text: undefined,
			redirectPath: undefined,
			data: undefined,
		},
	}))
	.on(openShareModal, (state, payload) => ({
		...state,
		shareModal: {
			isOpen: true,
			...payload,
		},
	}))
	.on(closeShareModal, (state) => ({
		...state,
		shareModal: {
			isOpen: false,
			title: undefined,
			description: undefined,
			shareParameters: undefined,
			saveShareParameters: undefined,
		},
	}))
	.on(openErrorLeagueModal, (state, {message}) => ({
		...state,
		errorLeagueModal: {
			message,
		},
	}))
	.on(closeErrorLeagueModal, (state) => ({
		...state,
		errorLeagueModal: {
			message: "",
		},
	}))
	.on(openGotcLeagueModal, (state) => ({
		...state,
		gotcLeagueModal: {
			isOpen: true,
		},
	}))
	.on(closeGotcLeagueModal, (state) => ({
		...state,
		gotcLeagueModal: {
			isOpen: false,
		},
	}));
